module.exports = __webpack_public_path__ + "static/media/boxie24.7e35adbe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/boxie24.webp
// module id = 257
// module chunks = 0